module.exports = "https://www.gc-pro.gnp.com.mx/d3dd77b2d0c69b6ab00826b65594c36e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-send.svg
// module id = 977
// module chunks = 0